import type { ReactNode } from "react";
import { classNames } from "../styles/classNames";

interface SectionProps {
  title: string;
  /** A short line that says what this part of the form is for. */
  hint?: string;
  /** Buttons beside the title, such as "Add". */
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** One titled part of a form or dialog, as a card. */
export default function Section({ title, hint, actions, className, children }: SectionProps) {
  return (
    <section className={classNames("app-card space-y-3 p-4", className)}>
      <header className="flex flex-wrap items-start justify-between gap-2">
        <div className="space-y-0.5">
          <h3 className="app-title text-sm font-semibold">{title}</h3>
          {hint === undefined ? null : <p className="app-help-text text-xs">{hint}</p>}
        </div>
        {actions === undefined ? null : <div className="flex flex-wrap gap-2">{actions}</div>}
      </header>
      {children}
    </section>
  );
}
